<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">

          <div class=" col-lg-12 col-md-12 col-12" v-if="user.role === '3'">
            <div>
              <h2 class="text-white">Bienvenido {{ user.name }}</h2>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-12" v-if="user.role === '1' || user.role === '2'">
            <router-link :to="{ name: 'Production' }" class="card-link">
              <card :title="stats.projects.title" :value="stats.projects.value" :percentage="stats.projects.percentage"
                :iconClass="stats.projects.iconClass" :iconBackground="stats.projects.iconBackground" directionReverse>
              </card>
            </router-link>
          </div>
          <div class="col-lg-3 col-md-6 col-12" v-if="user.role === '1' || user.role === '2'">
            <router-link :to="{ name: 'Users' }" class="card-link">
              <card :title="stats.users.title" :value="stats.users.value" :percentage="stats.users.percentage"
                :iconClass="stats.users.iconClass" :iconBackground="stats.users.iconBackground" directionReverse></card>
            </router-link>
          </div>

          <div class="col-lg-3 col-md-6 col-12" v-if="user.role === '1'">
            <!-- Siempre mostrar la opción de licencia al admin -->
            <div :class="(!isLicenseActiveThisMonth() || isLicenseExpiringSoon()) ? 'pulse-license' : ''">
              <router-link
                :to="{ name: 'Payment' }"
                class="card-link"
              >
                <card
                  :title="'Licencia'"
                  :detail="''"
                  :value="isLicenseActiveThisMonth() && license && license.status
                    ? (
                        license.status === 'paid' ? 'Pagado' :
                        license.status === 'pending' ? 'Pendiente' :
                        license.status === 'rejected' ? 'Rechazado' :
                        license.status === 'voided' ? 'Anulado' : 'Validando...'
                      )
                    : 'Renovar licencia'"
                  :percentage="getLicenseDate()"
                  :badge="getLicenseBadge()"
                  :badgeColor="getLicenseBadgeColor()"
                  :iconClass="'fa fa-id-card'"
                  :iconBackground="'bg-gradient-dark'"
                  :valueColor="getLicenseValueColor()"
                  :percentageColor="getLicensePercentageColor()"
                  directionReverse
                ></card>
              </router-link>
            </div>
          </div>

        </div>
        <div class="row" v-if="user.role === '1' || user.role === '2'">
          <div class="col-lg-12 mb-lg">
            <!-- line chart -->
            <div class="card">
              <gradient-line-chart />
            </div>
          </div>
          <div class="col-lg-5" hidden>
            <carousel />
          </div>
        </div>

        <!-- ---Sección de tareas y producción--- -->
        <div class="row mt-4 align-items-stretch" v-if="user.role === '1' || user.role === '2'">

          <!-- Tabla de tareas sin entregar -->
          <div class="col-lg-6 mb-lg-0 mb-4 d-flex">
            <div class="card w-100 d-flex flex-column">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">Tareas Sin Entregar</h6>
                </div>
                <div class="d-flex align-items-stretch mt-2">
                  <!-- Input de búsqueda -->
                  <input type="text" v-model="searchQuery" class="form-control"
                    placeholder="Buscar número de producción o usuario..." style="width:85%;">

                  <!-- Filtro -->
                  <div ref="undeliveredDropdown" class="dropdown ms-2" style="width:15%;"
                    :class="{ show: isFilterOpen }">
                    <button class="form-control dropdown-toggle h-100 d-flex justify-content-center align-items-center"
                      type="button" id="filterDropdown" @click="toggleFilter" :aria-expanded="isFilterOpen">
                      <i class="fa fa-filter"></i>
                    </button>

                    <ul class="dropdown-menu w-10" :class="{ show: isFilterOpen }" style="min-width:6rem; width:6rem;">
                      <li><a class="dropdown-item" href="#" @click.prevent="setFilter('Todos')">Todos</a></li>
                      <li><a class="dropdown-item" href="#" @click.prevent="setFilter('Mensualidad')">Mes</a>
                      </li>
                      <li><a class="dropdown-item" href="#" @click.prevent="setFilter('Tarea')">Tarea</a></li>
                    </ul>

                  </div>
                </div>
              </div>



              <div class="table-responsive flex-grow-1" style="overflow-y: auto; overflow-x: hidden; max-height: 500px;">
                <table class="table align-items-center table-fixed">
                  <thead class="sticky-top">
                    <tr>
                      <th class="col-prod">Producción</th>
                      <th class="col-user">Usuario</th>
                      <th class="col-days">Días</th>
                      <th class="col-date">Fec. Asig.</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, index) in filteredUndelivered" :key="index"
                      @click="redirectToProduction(value.production)" :style="value.production ? 'cursor: pointer;' : ''">
                      <td class="col-prod">
                        <div class="px-2 py-1">
                          <h6 class="mb-0 text-sm prod-name">
                            <span v-if="value.production">#{{ value.production.id }} - {{ value.production.name }}</span>
                            <span v-else>{{ value.description || 'Tarea flotante' }}</span>
                          </h6>
                        </div>
                      </td>

                      <td class="col-user">
                        <div>
                          <span class="text-xs d-block text-truncate">{{ value.user.name }}</span>
                          <span class="badge badge-sm"
                            :class="value.user?.payment === 0 ? 'bg-gradient-info' : 'bg-gradient-success'">
                            {{ value.user?.payment === 0 ? 'Mensualidad' : 'Tarea' }}
                          </span>
                        </div>
                      </td>
                      <td class="col-days align-middle">
                        <div class="days-cell">
                          <span :class="{
                            'badge bg-secondary text-light': value.days_since_delivered < 8,
                            'badge bg-warning text-light': value.days_since_delivered >= 8 && value.days_since_delivered <= 15,
                            'badge bg-danger': value.days_since_delivered > 15
                          }">
                            {{ value.days_since_delivered }}
                          </span>
                        </div>
                      </td>
                      <td class="col-date text-center">
                        <span class="text-xs">
                          {{ isValidDate(value.assigned_at) ? new Date(value.assigned_at).toLocaleDateString('es-ES')
                            : 'Sin asignar' }}
                        </span>
                      </td>
                    </tr>

                    <tr v-if="filteredUndelivered.length == 0">
                      <td class="text-center" colspan="4">
                        <p>No hay registros pendientes</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>


          <!-- Tabla de tareas sin validar -->
          <div class="col-lg-6 mb-lg-0 mb-4 d-flex">
            <div class="card w-100 d-flex flex-column">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">Tareas Entregadas Sin Validar</h6>
                </div>
                <div class="d-flex align-items-stretch mt-2">
                  <!-- Input de búsqueda -->
                  <input type="text" v-model="searchQueryUnvalidated" class="form-control"
                    placeholder="Buscar número de producción o usuario..." style="width:85%;">

                  <!-- Nuevo Filtro -->
                  <div ref="unvalidatedDropdown" class="dropdown ms-2" style="width:15%;"
                    :class="{ show: isFilterUnvalidatedOpen }">
                    <button class="form-control dropdown-toggle h-100 d-flex justify-content-center align-items-center"
                      type="button" @click="toggleUnvalidatedFilter" :aria-expanded="isFilterUnvalidatedOpen">
                      <i class="fa fa-filter"></i>
                    </button>

                    <ul class="dropdown-menu w-100" :class="{ show: isFilterUnvalidatedOpen }"
                      style="min-width:6rem; width:6rem;">
                      <li><a class="dropdown-item" href="#" @click.prevent="setFilterUnvalidated('Todos')">Todos</a>
                      </li>
                      <li><a class="dropdown-item" href="#" @click.prevent="setFilterUnvalidated('Mensualidad')">Mes</a>
                      </li>
                      <li><a class="dropdown-item" href="#" @click.prevent="setFilterUnvalidated('Tarea')">Tarea</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="table-responsive flex-grow-1" style="overflow-y: auto; overflow-x: hidden; max-height: 500px;">
                <table class="table align-items-center table-fixed">
                  <thead class="sticky-top">
                    <tr>
                      <th class="col-prod">Producción</th>
                      <th class="col-user">Usuario</th>
                      <th class="col-days">Días</th>
                      <th class="col-date">Fec. Asig.</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, index) in filteredUnvalidated" :key="index"
                      @click="redirectToProduction(value.production)" :style="value.production ? 'cursor: pointer;' : ''">
                      <td class="col-prod">
                        <div class="px-2 py-1">
                          <h6 class="mb-0 text-sm prod-name">
                            <span v-if="value.production">#{{ value.production.id }} - {{ value.production.name }}</span>
                            <span v-else>{{ value.description || 'Tarea flotante' }}</span>
                          </h6>
                        </div>
                      </td>
                      <td class="col-user">
                        <div>
                          <span class="text-xs d-block text-truncate">{{ value.user.name }}</span>
                          <span class="badge badge-sm"
                            :class="value.user?.payment === 0 ? 'bg-gradient-info' : 'bg-gradient-success'">
                            {{ value.user?.payment === 0 ? 'Mensualidad' : 'Tarea' }}
                          </span>
                        </div>
                      </td>
                      <td class="col-days align-middle">
                        <div class="days-cell">
                          <span :class="{
                            'badge bg-danger': value.days_since_delivered > 2,
                            'badge bg-secondary': value.days_since_delivered <= 2
                          }">
                            {{ value.days_since_delivered }}
                          </span>
                        </div>
                      </td>
                      <td class="col-date text-center">
                        <span class="text-xs">{{ new Date(value.received_date).toLocaleDateString('es-ES') }}</span>
                      </td>
                    </tr>
                    <tr v-if="filteredUnvalidated.length == 0">
                      <td class="text-center" colspan="4">
                        <p>No hay registros pendientes</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>


          <!-- Tabla de producción -->
          <div class="col-lg-12 mt-4 mb-lg-0 mb-4">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">Producción Activa</h6>
                </div>
                <!-- Input de búsqueda -->
                <input type="text" v-model="searchQueryProduction" class="form-control mt-2"
                  placeholder="Buscar producción...">
              </div>

              <div class="table-responsive" style="overflow-y: auto; overflow-x: hidden; max-height: 500px;">
                <table class="table align-items-center table-fixed">
                  <thead class="sticky-top">
                    <tr>
                      <th class="col-prod-wide">Producción</th>
                      <th class="col-days-wide">Días restantes</th>
                      <th class="col-date-wide">Fec. Entrega</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, index) in filteredProduction" :key="index" @click="redirectToProduction(value)"
                      style="cursor: pointer;">
                      <td class="col-prod-wide">
                        <div class="px-2 py-1">
                          <h6 class="mb-0 text-sm prod-name">#{{ value.id }} - {{ value.name }}</h6>
                        </div>
                      </td>
                      <td class="col-days-wide align-middle">
                        <div class="days-cell">
                          <span :class="{
                            'badge bg-danger': value.days_since_delivered < 0,
                            'badge bg-secondary': value.days_since_delivered > 2
                          }">
                            {{ value.days_since_delivered }}
                          </span>
                        </div>
                      </td>
                      <td class="col-date-wide text-center">
                        <span class="text-xs">{{ new Date(value.delivery_date +
                          'T00:00:00').toLocaleDateString('es-ES') }}</span>
                      </td>
                    </tr>
                    <tr v-if="filteredProduction.length == 0">
                      <td class="text-center" colspan="3">
                        <p>No hay registros pendientes</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>


          <!-- Tabla de producción terminada -->
          <div class="col-lg-12 mt-4 mb-lg-0 mb-4">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">Producción Terminada</h6>
                </div>
                <!-- Input de búsqueda -->
                <input type="text" v-model="searchQueryProductionFinish" class="form-control mt-2"
                  placeholder="Buscar producción...">
              </div>
              <div class="table-responsive" style="overflow-y: auto; overflow-x: hidden; max-height: 500px;">
                <table class="table align-items-center table-fixed">
                  <thead class="sticky-top">
                    <tr>
                      <th class="col-prod-wide">Producción</th>
                      <th class="col-date-wide">Fec. Creación</th>
                      <th class="col-date-wide">Fec. Entrega</th>
                      <th class="col-days-wide">Diferencia</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, index) in filteredProductionFinish" :key="index"
                      @click="redirectToProduction(value)" style="cursor: pointer;">
                      <td class="col-prod-wide">
                        <div class="px-2 py-1">
                          <h6 class="mb-0 text-sm prod-name">#{{ value.id }} - {{ value.name }}</h6>
                        </div>
                      </td>
                      <td class="col-date-wide text-center">
                        <span class="text-xs">{{ new Date(value.delivery_date +
                          'T00:00:00').toLocaleDateString('es-ES') }}</span>
                      </td>
                      <td class="col-date-wide text-center">
                        <span class="text-xs">{{ new Date(value.created_at).toLocaleDateString('es-ES') }}</span>
                      </td>
                      <td class="col-days-wide align-middle">
                        <div class="days-cell">
                          <span class="text-xs">{{ value.time_difference }}</span>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="filteredProductionFinish.length == 0">
                      <td class="text-center" colspan="4">
                        <p>No hay registros</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Envíos locales -->
          <div class="col-lg-12 mt-4 mb-lg-0 mb-4">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between align-items-center">
                  <h6 class="mb-2">Envíos Locales</h6>
                  <button class="btn btn-success btn-sm mb-2" type="button"
                    :disabled="isExportingLocalDelivery || !localDeliveryRows.length" @click="exportLocalDelivery">
                    <i class="fas me-1" :class="isExportingLocalDelivery ? 'fa-spinner fa-spin' : 'fa-file-excel'"></i>
                    Descargar Excel
                  </button>
                </div>
                <div class="row g-2">
                  <div class="col-md-4 col-6">
                    <label class="text-xs text-secondary mb-0">Desde</label>
                    <input type="date" v-model="localDeliveryFilters.from" class="form-control form-control-sm"
                      @change="fetchLocalDelivery">
                  </div>
                  <div class="col-md-4 col-6">
                    <label class="text-xs text-secondary mb-0">Hasta</label>
                    <input type="date" v-model="localDeliveryFilters.to" class="form-control form-control-sm"
                      @change="fetchLocalDelivery">
                  </div>
                  <div class="col-md-4 col-12">
                    <label class="text-xs text-secondary mb-0">Mensajero</label>
                    <select v-model="localDeliveryFilters.user_id" class="form-select form-select-sm"
                      @change="fetchLocalDelivery">
                      <option value="">Todos</option>
                      <option v-for="u in localDeliveryUsers" :key="u.id" :value="u.id">{{ u.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="card-body p-3">
                <div class="row g-2 mb-3">
                  <div class="col-6">
                    <div class="border rounded p-2">
                      <p class="text-xs text-secondary mb-0">Pedidos</p>
                      <h5 class="mb-0">{{ localDeliveryRows.length }}</h5>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="border rounded p-2">
                      <p class="text-xs text-secondary mb-0">Total pagado</p>
                      <h5 class="mb-0">{{ formatMoney(localDeliveryTotal) }}</h5>
                    </div>
                  </div>
                </div>
                <div class="chart" style="height: 260px;">
                  <canvas ref="localDeliveryChart" class="chart-canvas"></canvas>
                </div>
                <div class="table-responsive mt-3" style="overflow-y: auto; max-height: 400px;">
                  <table class="table align-items-center mb-0">
                    <thead class="sticky-top">
                      <tr>
                        <th class="text-xs">Fecha</th>
                        <th class="text-xs">Pedido</th>
                        <th class="text-xs">Cliente</th>
                        <th class="text-xs">Mensajero</th>
                        <th class="text-xs text-end">Valor pagado</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in localDeliveryRows" :key="row.id" style="cursor: pointer;"
                        @click="redirectToOrder(row)">
                        <td class="text-xs">{{ formatDay(row.date) }}</td>
                        <td class="text-xs">{{ row.order }}</td>
                        <td class="text-xs">{{ row.customer_name || '—' }}</td>
                        <td class="text-xs">{{ row.user_name || '—' }}</td>
                        <td class="text-xs text-end">{{ formatMoney(row.amount) }}</td>
                      </tr>
                      <tr v-if="localDeliveryRows.length == 0">
                        <td class="text-center" colspan="5">
                          <p class="mb-0">No hay envíos locales en el rango</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>







      </div>
    </div>

    <!-- Modal de licencia vencida -->
    <div v-if="showLicenseModal" class="license-modal-overlay">
      <div class="license-modal-box">
        <div class="license-modal-icon">
          <i class="fas fa-exclamation"></i>
        </div>
        <h2 class="license-modal-title">¡Tu licencia ha vencido!</h2>
        <p class="license-modal-text">
          Tu licencia venció el <strong>{{ licenseExpiredDate }}</strong>. Renuévala para seguir disfrutando de todos los beneficios de Mi Stock.
        </p>
        <button class="license-modal-btn" @click="goToPayment">
          <i class="fas fa-credit-card"></i>
          Renovar ahora
        </button>
        <a href="#" class="license-modal-link" @click.prevent="dismissLicenseModal">Recordar más tarde</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* ---- Modal licencia vencida ---- */
.license-modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.license-modal-box {
  background: #fff;
  border-radius: 22px;
  padding: 42px 36px 30px;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0,0,0,0.18);
}
.license-modal-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #ff4757;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 22px;
}
.license-modal-icon i {
  color: #fff;
  font-size: 30px;
  font-weight: 900;
}
.license-modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 12px;
  letter-spacing: -0.2px;
}
.license-modal-text {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.55;
  margin: 0 0 28px;
}
.license-modal-text strong {
  color: #374151;
  font-weight: 700;
}
.license-modal-btn {
  width: 100%;
  background: #ff4757;
  color: #fff;
  border: none;
  border-radius: 50px;
  padding: 14px 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  transition: background 0.2s, transform 0.1s;
  box-shadow: 0 6px 16px rgba(255, 71, 87, 0.35);
}
.license-modal-btn:hover {
  background: #ff6b81;
}
.license-modal-btn:active {
  transform: scale(0.98);
}
.license-modal-btn i {
  font-size: 16px;
}
.license-modal-link {
  display: block;
  margin-top: 18px;
  font-size: 13px;
  color: #4b5563;
  font-weight: 500;
  text-decoration: none;
}
.license-modal-link:hover {
  color: #111827;
}

.dropdown-toggle::after {
  display: none !important;
}

/* ---- Tablas de dashboard ---- */
.table-fixed {
  table-layout: fixed;
  width: 100%;
}

.table-fixed thead th {
  font-size: 0.68rem !important;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  opacity: 0.8;
  background: #fff;
  border-bottom: 1px solid #dee2e6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  z-index: 10;
  padding: 0.4rem 0.25rem !important;
  text-align: center;
}

.table-fixed thead th.col-prod,
.table-fixed thead th.col-user,
.table-fixed thead th.col-prod-wide {
  text-align: left;
  padding-left: 0.75rem !important;
}

/* Columnas para tablas de 4 columnas (Tareas Sin Entregar / Sin Validar) */
.col-prod { width: 38%; }
.col-user { width: 27%; }
.col-days { width: 10%; }
.col-date { width: 25%; }

/* Columnas para tabla de 3 columnas (Producción Activa) */
.col-prod-wide { width: 55%; }
.col-days-wide { width: 18%; }
.col-date-wide { width: 27%; }

/* Producción: máximo 2 líneas con elipsis */
.prod-name {
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  white-space: normal !important;
  line-height: 1.3;
  font-size: 0.72rem !important;
}

/* Asegurar que el contenido de las celdas no expanda la tabla */
.table-fixed td {
  overflow: hidden;
  word-break: break-word;
  font-size: 0.72rem !important;
}

/* Badge de días centrado */
.table-fixed .days-cell {
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
<script>
import Card from "@/examples/Cards/Card.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import Carousel from "./components/Carousel.vue";
import Chart from "chart.js/auto";
import analitycService from "@/services/analityc.service";

const toInputDate = (d) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export default {
  name: "dashboard-default",
  data() {
    return {
      searchQuery: '',
      searchQueryUnvalidated: '',
      searchQueryProduction: '',
      searchQueryProductionFinish: '',
      stats: {
        projects: {
          title: "Producción activa",
          value: "0",
          percentage: "0%",
          iconClass: "ni ni-folder-17",
          detail: "since yesterday",
          iconBackground: "bg-gradient-info",
        },
        users: {
          title: "Usuarios",
          value: "0",
          percentage: "0%",
          iconClass: "ni ni-user-run",
          iconBackground: "bg-gradient-danger",
          detail: "since last week",
        },
      },
      user: {},
      undelivered: [],
      unvalidated: [],
      production: [],
      productionFinish: [],
      license: {
        status: null,
        coverage_month: null
      },
      filterType: 'Todos',
      isFilterOpen: false,
      filterTypeUnvalidated: 'Todos',
      isFilterUnvalidatedOpen: false,
      showLicenseModal: false,
      localDeliveryFilters: {
        from: toInputDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
        to: toInputDate(new Date()),
        user_id: '',
      },
      localDeliveryRows: [],
      localDeliveryUsers: [],
      isExportingLocalDelivery: false,
    };
  },
  components: {
    Card,
    GradientLineChart,
    Carousel,
  },
  computed: {
    localDeliveryTotal() {
      return this.localDeliveryRows.reduce((sum, row) => sum + Number(row.amount || 0), 0);
    },
    // Pedidos y total por día; rellena con 0 los días sin envíos del rango
    localDeliveryByDay() {
      const map = new Map();
      const { from, to } = this.localDeliveryFilters;
      if (from && to) {
        const end = new Date(to + 'T00:00:00');
        for (let d = new Date(from + 'T00:00:00'); d <= end && map.size < 366; d.setDate(d.getDate() + 1)) {
          map.set(toInputDate(d), { orders: 0, total: 0 });
        }
      }
      for (const row of this.localDeliveryRows) {
        if (!row.date) continue;
        const day = map.get(row.date) || { orders: 0, total: 0 };
        day.orders += 1;
        day.total += Number(row.amount || 0);
        map.set(row.date, day);
      }
      return [...map.entries()]
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([date, v]) => ({ date, ...v }));
    },
    licenseExpiredDate() {
      const coverage = this.parseCoverageDate(this.license?.coverage_month);
      return coverage ? coverage.toLocaleDateString('es-ES') : '';
    },

    filteredUndelivered() {
      const list = Array.isArray(this.undelivered) ? this.undelivered : [];
      // si no hay texto ni filtro → muestra todo
      if (!this.searchQuery && this.filterType === 'Todos') return list;

      const q = this.searchQuery.toLowerCase();

      return list.filter(value => {
        if (!value) return false;
        /* -------- filtro por tipo -------- */
        const tipo = value.user?.payment === 0 ? 'Mensualidad' : 'Tarea';
        if (this.filterType !== 'Todos' && tipo !== this.filterType) return false;

        /* -------- filtro por búsqueda -------- */
        if (!q) return true;   // solo filtraba por tipo

        const productionId = (value.production?.id ?? '').toString().toLowerCase();
        const userName = (value.user?.name ?? '').toLowerCase();
        return productionId.includes(q) || userName.includes(q);
      });
    },
    filteredUnvalidated() {
      const list = Array.isArray(this.unvalidated) ? this.unvalidated : [];
      // Filtrado combinado de búsqueda y tipo
      const q = this.searchQueryUnvalidated.toLowerCase();

      return list.filter(value => {
        if (!value) return false;
        // Filtro por tipo
        const tipo = value.user?.payment === 0 ? 'Mensualidad' : 'Tarea';
        if (this.filterTypeUnvalidated !== 'Todos' && tipo !== this.filterTypeUnvalidated) return false;

        // Filtro por búsqueda
        if (!q) return true;

        const productionId = (value.production?.id ?? '').toString().toLowerCase();
        const userName = (value.user?.name ?? '').toLowerCase();
        return productionId.includes(q) || userName.includes(q);
      });
    },
    filteredProduction() {
      const list = Array.isArray(this.production) ? this.production : [];
      if (!this.searchQueryProduction) return list;

      return list.filter(value => {
        if (!value) return false;
        const productionId = (value.id ?? '').toString().toLowerCase();
        const productionName = (value.name ?? '').toLowerCase();
        const query = this.searchQueryProduction.toLowerCase();
        return productionId.includes(query) || productionName.includes(query);
      });
    },
    filteredProductionFinish() {
      const list = Array.isArray(this.productionFinish) ? this.productionFinish : [];
      if (!this.searchQueryProductionFinish) return list;

      return list.filter(value => {
        if (!value) return false;
        const productionId = (value.id ?? '').toString().toLowerCase();
        const productionName = (value.name ?? '').toLowerCase();
        const query = this.searchQueryProduction.toLowerCase();
        return productionId.includes(query) || productionName.includes(query);
      });
    }
  },
  methods: {
    formatMoney(value) {
      return Number(value || 0).toLocaleString('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 });
    },
    formatDay(date) {
      return date ? new Date(date + 'T00:00:00').toLocaleDateString('es-ES') : '—';
    },
    localDeliveryParams() {
      const { from, to, user_id } = this.localDeliveryFilters;
      return { from: from || undefined, to: to || undefined, user_id: user_id || undefined };
    },
    async fetchLocalDelivery() {
      try {
        const response = await analitycService.getLocalDelivery(this.localDeliveryParams());
        this.localDeliveryRows = Array.isArray(response?.data?.rows) ? response.data.rows : [];
        this.localDeliveryUsers = Array.isArray(response?.data?.users) ? response.data.users : [];
      } catch (e) {
        this.localDeliveryRows = [];
        this.localDeliveryUsers = [];
      }
      this.renderLocalDeliveryChart();
    },
    renderLocalDeliveryChart() {
      const canvas = this.$refs.localDeliveryChart;
      if (!canvas) return;
      const days = this.localDeliveryByDay;
      if (this.localDeliveryChart) this.localDeliveryChart.destroy();
      this.localDeliveryChart = new Chart(canvas.getContext('2d'), {
        type: 'bar',
        data: {
          labels: days.map((d) => this.formatDay(d.date).slice(0, 5)),
          datasets: [{
            label: 'Total pagado',
            data: days.map((d) => d.total),
            backgroundColor: '#3987e5',
            borderRadius: 4,
            maxBarThickness: 24,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                title: (items) => this.formatDay(days[items[0].dataIndex].date),
                label: (ctx) => {
                  const day = days[ctx.dataIndex];
                  return [`Pedidos: ${day.orders}`, `Total: ${this.formatMoney(day.total)}`];
                },
              },
            },
          },
          interaction: { intersect: false, mode: 'index' },
          scales: {
            y: {
              beginAtZero: true,
              grid: { drawBorder: false, borderDash: [5, 5] },
              ticks: { callback: (v) => this.formatMoney(v) },
            },
            x: { grid: { display: false, drawBorder: false } },
          },
        },
      });
    },
    async exportLocalDelivery() {
      this.isExportingLocalDelivery = true;
      try {
        const response = await analitycService.exportLocalDelivery(this.localDeliveryParams());
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = `envios_locales_${this.localDeliveryFilters.from || ''}_${this.localDeliveryFilters.to || ''}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.error('Error al exportar envíos locales:', e);
      } finally {
        this.isExportingLocalDelivery = false;
      }
    },
    redirectToOrder(row) {
      this.$router.push({ name: 'Shopify Order Detail', query: { source: row.source || 'shopify', id: row.id } });
    },
    parseCoverageDate(dateStr) {
      if (!dateStr) return null;
      const dateOnly = dateStr.toString().split('T')[0].split(' ')[0];
      if (!/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) return null;
      const localDate = new Date(dateOnly + 'T00:00:00');
      return isNaN(localDate.getTime()) ? null : localDate;
    },
    redirectToProduction(value) {
      if (!value || !value.id) return;
      this.$router.push({
        name: 'Production Create',
        query: { id: value.id }
      });
    },
    isValidDate(date) {
      if (!date) {
        return false;
      }
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
    async fetchAnalytics() {
      try {
        await this.$store.dispatch('analitycs/getCards');
        this.stats = this.$store.state.analitycs.cards;
      } catch (e) {
        // Si el endpoint falla (404/500), no romper el Dashboard
        this.stats.projects.value = "0";
        this.stats.users.value = "0";
      }
    },
    async fetchUndelivered() {
      try {
        let datos = await this.$store.dispatch('analitycs/getUndelivered');
        const payload = datos?.data;
        const list = Array.isArray(payload) ? payload : (Array.isArray(payload?.data) ? payload.data : []);
        this.undelivered = list;
      } catch (e) {
        this.undelivered = [];
      }
    },
    async fetchUnvalidated() {
      try {
        let datos = await this.$store.dispatch('analitycs/getUnvalidate');
        const payload = datos?.data;
        const list = Array.isArray(payload) ? payload : (Array.isArray(payload?.data) ? payload.data : []);
        this.unvalidated = list;
      } catch (e) {
        this.unvalidated = [];
      }
    },
    async fetchProduction() {
      try {
        let datos = await this.$store.dispatch('analitycs/getProduction');
        const payload = datos?.data;
        const list = Array.isArray(payload) ? payload : (Array.isArray(payload?.data) ? payload.data : []);
        this.production = list;
      } catch (e) {
        this.production = [];
      }
    },
    async fetchProductionFinish() {
      try {
        let datos = await this.$store.dispatch('analitycs/getProductionFinish');
        const payload = datos?.data;
        const list = Array.isArray(payload) ? payload : (Array.isArray(payload?.data) ? payload.data : []);
        this.productionFinish = list;
      } catch (e) {
        this.productionFinish = [];
      }
    },
    async fetchLicense() {
      try {
        const lic = await this.$store.dispatch('payments/get');
        this.license = lic ?? null;
        this.checkLicenseExpired();
      } catch (e) {
        this.license = null;
      }
    },
    checkLicenseExpired() {
      const days = this.getLicenseDaysRemaining();
      if (days !== null && days < 0) {
        this.showLicenseModal = true;
      }
    },
    goToPayment() {
      this.showLicenseModal = false;
      this.$router.push({ name: 'Payment' });
    },
    dismissLicenseModal() {
      this.showLicenseModal = false;
    },
    isLicenseActiveThisMonth() {
      if (!this.license || !this.license.status || !this.license.coverage_month) {
        return false;
      }
      try {
        const coverage = this.parseCoverageDate(this.license.coverage_month);
        if (!coverage || isNaN(coverage.getTime())) return false;
        const now = new Date();
        // Consideramos "pago activo" si está pagado y la fecha de cobertura es hoy o una fecha futura
        return this.license.status == 'paid' && coverage >= now;
      } catch (e) {
        return false;
      }
    },
    isLicenseExpiringSoon() {
      const days = this.getLicenseDaysRemaining();
      return days !== null && days > 0 && days <= 3;
    },
    getLicenseDaysRemaining() {
      if (!this.license || !this.license.coverage_month) return null;
      const coverage = this.parseCoverageDate(this.license.coverage_month);
      if (!coverage || isNaN(coverage.getTime())) return null;
      const now = new Date();
      const diffTime = coverage - now;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },
    getLicenseDate() {
      const coverage = this.parseCoverageDate(this.license?.coverage_month);
      return coverage ? coverage.toLocaleDateString('es-ES') : 'Sin licencia activa';
    },
    getLicenseBadge() {
      const days = this.getLicenseDaysRemaining();
      if (days === null || days > 3) return '';
      if (days > 0) return `Vence en ${days} días`;
      if (days === 0) return 'Vence hoy';
      return `Vencida hace ${Math.abs(days)} días`;
    },
    getLicenseBadgeColor() {
      const days = this.getLicenseDaysRemaining();
      if (days === null) return 'bg-gradient-danger';
      if (days <= 0) return 'bg-gradient-danger';
      if (days <= 3) return 'bg-gradient-warning';
      return 'bg-gradient-info';
    },
    getLicensePercentage() {
      const coverage = this.parseCoverageDate(this.license?.coverage_month);
      const dateStr = coverage ? coverage.toLocaleDateString('es-ES') : 'Sin licencia activa';
      const days = this.getLicenseDaysRemaining();
      if (days === null || days > 3) return dateStr;
      if (days > 0) return `Vence en ${days} días - ${dateStr}`;
      if (days === 0) return `Vence hoy - ${dateStr}`;
      return `Vencida hace ${Math.abs(days)} días - ${dateStr}`;
    },
    getLicensePercentageColor() {
      const days = this.getLicenseDaysRemaining();
      if (days === null) return 'text-danger';
      if (days <= 0) return 'text-danger';
      if (days <= 3) return 'text-warning';
      return this.getStatusColor(this.license.status);
    },
    getLicenseValueColor() {
      if (!this.isLicenseActiveThisMonth()) return 'text-danger';
      const days = this.getLicenseDaysRemaining();
      if (days !== null && days <= 3 && days > 0) return 'text-warning';
      return this.getStatusColor(this.license.status);
    },
    getStatusColor(status) {
      if (!status) return 'text-secondary';
      switch (status) {
        case 'paid':
          return 'text-success';  // Color verde para "Pagado"
        case 'pending':
          return 'text-warning';  // Color amarillo para "Pendiente"
        case 'rejected':
          return 'text-danger';   // Color rojo para "Rechazado"
        case 'voided':
          return 'text-muted';    // Color gris para "Anulado"
        default:
          return 'text-secondary'; // Color por defecto
      }
    },
    /* ---------- filtros ---------- */
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;
      this.isFilterUnvalidatedOpen = false;
    },
    toggleUnvalidatedFilter() {
      this.isFilterUnvalidatedOpen = !this.isFilterUnvalidatedOpen;
      this.isFilterOpen = false;
    },
    /* seleccionar opción y cerrar */
    setFilter(tipo) {
      this.filterType = tipo;
      this.isFilterOpen = false;
    },
    setFilterUnvalidated(tipo) {
      this.filterTypeUnvalidated = tipo;
      this.isFilterUnvalidatedOpen = false;
    },
    /* click fuera */
    onClickOutside(e) {
      if (
        this.isFilterOpen &&
        this.$refs.undeliveredDropdown &&
        !this.$refs.undeliveredDropdown.contains(e.target)
      ) {
        this.isFilterOpen = false;
      }
      if (
        this.isFilterUnvalidatedOpen &&
        this.$refs.unvalidatedDropdown &&
        !this.$refs.unvalidatedDropdown.contains(e.target)
      ) {
        this.isFilterUnvalidatedOpen = false;
      }
    },

  },
  async mounted() {
    document.addEventListener("click", this.onClickOutside);


    let user = JSON.parse(localStorage.getItem('user'));
    this.user = user;

    // Redirigir operadores a su dashboard
    if (user && user.role === '3') {
      this.$router.push({ name: 'Operador Dashboard' });
      return;
    }

    if (user.role === '1' || user.role === '2') {
      this.fetchAnalytics();
      this.fetchUndelivered();
      this.fetchUnvalidated();
      this.fetchProduction();
      this.fetchProductionFinish();
      this.fetchLocalDelivery();
      this.fetchLicense();
    }


  },
  beforeUnmount() {
    document.removeEventListener("click", this.onClickOutside);
    if (this.localDeliveryChart) this.localDeliveryChart.destroy();
  },
};
</script>

<style scoped>
.pulse-license {
  display: inline-block;
  /* Animación cada 5 segundos */
  animation: license-bounce 5s ease-in-out infinite;
}

@keyframes license-bounce {
  0%   { transform: translateY(0) scale(1); }
  5%   { transform: translateY(-8px) scale(1.03); }
  10%  { transform: translateY(0) scale(1); }
  15%  { transform: translateY(-4px) scale(1.02); }
  20%  { transform: translateY(0) scale(1); }
  100% { transform: translateY(0) scale(1); }
}
</style>
